var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('menu-item-link');
import { breakpoints, theme } from '@shapeable/theme';
import { useLink } from '../hooks/use-link';
import { Icon } from '../elements/icon';
import { includes } from 'lodash';
import { useLang } from '../hooks/use-lang';
import { useComponentProps } from '../context/component-props-context';
export var MenuItemHeight = {
  header: 61
};
export var MenuItemMinimisedHeight = {
  header: 44
};
export var MenuItemVerticalUnitPadding = {
  default: 0,
  inverted: 0,
  header: 0,
  footer: 0
};
export var MenuItemMinimisedVerticalUnitPadding = {
  default: 1,
  inverted: 1,
  header: 0,
  footer: 0
};
export var MenuItemHorizonalUnitPadding = {
  default: 2,
  inverted: 2,
  header: 2,
  footer: 0
};
export var MenuItemMinimisedHorizonalUnitPadding = {
  default: 0.5,
  inverted: 0.5,
  header: 0.5,
  footer: 0
};
export var MenuItemLinkDefaultProps = {
  variant: 'default',
  iconSize: 12,
  barHeight: 2,
  colors: {
    text: 'strong',
    border: 'strong',
    hover: {
      text: 'primary',
      fill: 'primary'
    },
    active: {
      text: 'linkActive',
      border: 'strong',
      fill: 'linkActive'
    }
  },
  showActiveBar: true,
  style: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    box-sizing: border-box;\n    display: inline-block;\n    transition: border 0.2s ease-in-out;\n    \n    ", "\n\n    ", "\n    \n    ", "\n\n  "], ["\n    box-sizing: border-box;\n    display: inline-block;\n    transition: border 0.2s ease-in-out;\n    \n    ", "\n\n    ", "\n    \n    ", "\n\n  "])), function (_a) {
    var colors = _a.colors,
      isActive = _a.isActive;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      ", ";\n    "], ["\n      ", ";\n      ", ";\n    "])), theme.APPLY_COLORS({
      colors: colors,
      isActive: isActive,
      selector: cls.child('label')
    }), theme.APPLY_COLORS({
      colors: colors,
      isActive: isActive
    }));
  }, function (_a) {
    var barHeight = _a.barHeight,
      isActive = _a.isActive;
    return isActive && barHeight && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom-width: ", "px;\n      border-bottom-style: solid;\n    "], ["\n      border-bottom-width: ", "px;\n      border-bottom-style: solid;\n    "])), barHeight);
  }, function (_a) {
    var variant = _a.variant;
    return MenuItemHeight[variant] && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), MenuItemHeight[variant]);
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: 1em;\n    display: flex;\n    user-select: none;\n    justify-content: space-between;\n    align-items: center;\n    text-decoration: none;\n    transition: color 0.3s ease-in-out;\n    white-space: nowrap;\n\n    ", "\n\n\n        \n  "], ["\n    font-family: ", ";\n    font-size: 1em;\n    display: flex;\n    user-select: none;\n    justify-content: space-between;\n    align-items: center;\n    text-decoration: none;\n    transition: color 0.3s ease-in-out;\n    white-space: nowrap;\n\n    ", "\n\n\n        \n  "])), theme.FONT('sans'), function (_a) {
    var variant = _a.variant;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme.UNIT(MenuItemVerticalUnitPadding[variant]), theme.UNIT(MenuItemHorizonalUnitPadding[variant]));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-left: ", ";\n    path, rect, circle, polygon {\n      transition: fill 0.2s ease-in-out;\n    }\n  "], ["\n    margin-left: ", ";\n    path, rect, circle, polygon {\n      transition: fill 0.2s ease-in-out;\n    }\n  "])), theme.UNIT(3))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    cursor: pointer;\n  "], ["\n    cursor: pointer;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'MenuItemLink',
  Container: styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: styled.span.attrs(cls.attr('button'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Label: styled.span.attrs(cls.attr('label'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var MenuItemLink = function (props) {
  var _a = useComponentProps(My.NAME, MenuItemLinkDefaultProps, props),
    className = _a.className,
    children = _a.children,
    variant = _a.variant,
    isActive = _a.isActive,
    entity = _a.entity,
    onClick = _a.onClick,
    icon = _a.icon,
    iconSize = _a.iconSize,
    barHeight = _a.barHeight,
    showActiveBar = _a.showActiveBar,
    colors = _a.colors;
  var Link = useLink().Link;
  var style = __assign({
    textDecoration: 'none'
  }, props.style || {});
  var t = useLang();
  var page = entity.page,
    path = entity.path,
    name = entity.name,
    url = entity.url;
  var href = url || path || page && page.path;
  var hasBar = includes(['header'], variant) && showActiveBar;
  var inner = React.createElement(My.Label, {
    variant: variant,
    isActive: isActive
  }, children || t(name || page && (page.title || page.name)), icon && React.createElement(My.Icon, {
    size: iconSize
  }, icon));
  return React.createElement(My.Container, {
    variant: variant,
    barHeight: hasBar && barHeight,
    isActive: isActive,
    colors: colors,
    className: cls.name(className)
  }, onClick ? React.createElement(My.Button, {
    onClick: onClick
  }, inner) : React.createElement(Link, {
    style: style,
    href: href
  }, inner));
};
//MenuItemLink.defaultProps = MenuItemLinkDefaultProps;
MenuItemLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;